<template>
  <div class="card">
    <div class="card-body">
      <div style="position:relative;">
        <h2>Distributors</h2>
        <div style="position: absolute;right: 0;top: 0;">
          <a href="/distributors/export" class="btn btn-primary"
          >
            <i class="fa fa-file-alt"></i> Export
          </a>
          <button type="button" class="btn btn-primary"
            @click="openCreateModal"
          >
            <i class="fa fa-plus"></i> Create
          </button>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Company Name</th>
            <th scope="col">Country</th>
            <th scope="col">Website</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="distributor in distributors">
            <th scope="row">{{ distributor.company_name }}</th>
            <th></th>
            <th>{{ distributor.website }}</th>
            <td class="text-right">
              <div class="nowrap">
                <button type="button" class="btn btn-warning btn-sm"
                  @click="openEditModal(distributor)"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn btn-secondary btn-sm"
                  @click="deleteDistributor(distributor)"
                >
                  <i class="fa fa-trash-alt"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <cu-modal :modalContent="modalContent"
      v-if="modalContent"
      @distributorUpdated="distributorUpdated"
      @distributorStored="distributorStored"
    />
  </div>
</template>

<script>
  import CuModal from './CuModal.vue'
  export default {
    props: ['initDistributors'],
    components: { CuModal },
    data() {
      return {
        distributors: this.initDistributors,
        modalContent: null,
      }
    },
    methods: {
      openCreateModal () {
        this.modalContent = {
          title: `Create Distributor`,
          formClassFields: {
            company_name: '',
            adress: '',
            website: '',
            gm_name: '',
            gm_phone: '',
            gm_email: '',
            marketing_name: '',
            marketing_phone: '',
            marketing_email: '',
          },
          submitMethod: 'post',
          submitUrl: `/distributors`,
          successEvent: 'distributorStored',
          submitText: 'Create',
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      distributorStored (distributor) {
        this.distributors.push(distributor)
      },
      openEditModal (distributor) {
        this.modalContent = {
          title: `Edit ${distributor.company_name}`,
          formClassFields: distributor,
          submitMethod: 'put',
          submitUrl: `/distributors/${distributor.id}`,
          successEvent: 'distributorUpdated',
          submitText: 'Save',
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      distributorUpdated (distributor) {
        window.notification.success(`${distributor.company_name} has been updated`, 'Success!')
        const index = this.distributors.findIndex(eDistributor => eDistributor.id === distributor.id)
        this.distributors.splice(index, 1, distributor)
        $('#cuModal').modal('hide')
      },
      deleteDistributor (distributor) {
        if (window.confirm(`Do you really want to delete the Distributor ${distributor.company_name}?`)) {
          window.axios.delete(`/distributors/${distributor.id}`).then(({data}) => {
            window.notification.success(`${data.company_name} has been deleted`, 'Success!')
            const index = this.distributors.findIndex(eDistributor => eDistributor.id === distributor.id)
            this.distributors.splice(index, 1)
          })
        }
      },
    },
    mounted() {
      $(document).on('hide.bs.modal', '#cuModal', () => this.modalContent = null)
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/distributors/DistributorsIndex.vue